import { useEffect, useState } from 'react';

import cn from 'classnames';
import { CandidateCheckScreens } from 'constants/candidate_screens';
import { buildNavPath as buildNavPathHelper } from 'helpers/candidate_application/form-page-helpers';
import { useQueryParams } from 'hooks/query-params';
import { useUserAgent } from 'hooks/user-agent';
import CandidatePage from 'layouts/CandidatePage/CandidatePage';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { shouldSubmitCandidate } from 'utils/checks-utils';

import { CustomButton } from '../components/CustomButton/CustomButton';
import { Dialog } from 'components/Dialog/Dialog';

import {
  selectCandidateApplication,
  submitCandidateApplication,
  updateBackyCheck,
} from 'api/candidate-application-slice';

import styles from './CandidateBackyPortal.module.scss';

export const CandidateBackyPortal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [admin] = useQueryParams(['admin']);

  // Helper to build navigation path with admin parameter preserved
  const buildNavPath = path => buildNavPathHelper(path, admin);

  const { user_agent } = useUserAgent();
  const { token } = useParams();

  const {
    application: { candidate_checks, brand, check_types },
    fetched,
  } = useSelector(selectCandidateApplication);

  const [check, setCheck] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!fetched) return;

    setCheck(candidate_checks.find(check => check.type === 'afp_backy'));
  }, [fetched]);

  const verifyAndReturn = async () => {
    setLoading(true);
    await dispatch(updateBackyCheck({ token, id: check.id }));
    if (shouldSubmitCandidate(check, candidate_checks, check_types)) {
      await dispatch(submitCandidateApplication({ token, user_agent }));
      setLoading(false);
      navigate(
        buildNavPath(`/form_submission/candidate/${CandidateCheckScreens.SUCCESS}/${token}`),
      );
    } else {
      setLoading(false);
      navigate(buildNavPath(`/form_submission/candidate/dashboard/${token}`));
    }
  };

  return (
    <CandidatePage loading={loading} token={token} title="Australian Federal Police Check">
      <CandidatePage.View>
        <Dialog header="Here are your Backy Check credentials.">
          <Dialog.Message>
            <p>User: {check?.details.username}</p>
            <p>Pass: {check?.details.password}</p>
          </Dialog.Message>
        </Dialog>

        <div className={styles.root}>
          <div
            className={cn(
              styles.frameWrapper,
              'card',
              'card-with-border',
              'card-with-hidden-overflow',
            )}>
            <iframe src="https://portal.backycheck.com" />
          </div>
          <CustomButton brand={brand} onClick={verifyAndReturn}>
            Submit
          </CustomButton>
        </div>
      </CandidatePage.View>
    </CandidatePage>
  );
};

export default CandidateBackyPortal;
